exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.text-muted.chosen {\r\n    color: rgb(53, 53, 157) !important;\r\n    font-weight: bold;\r\n}\r\n\r\n.shadow {\r\n  -webkit-filter: drop-shadow(5px 5px 5px #222);\r\n  filter: drop-shadow(5px 5px 5px #222);\r\n}\r\n\r\n.bottom-button {\r\n  vertical-align: bottom;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/grim-pack/grim-pack.component.css
// module id = ../../../../../src/app/containers/grim-pack/grim-pack.component.css
// module chunks = main